var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNav1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill-color",
    fillRule: "evenodd",
    d: "M502.357,423.808c0.019-.077.043-0.15,0.059-0.229C503.365,419.962,504,413.462,504,406s-0.639-13.966-1.588-17.584c-0.016-.078-0.04-0.151-0.059-0.23-0.03-.111-0.058-0.247-0.09-0.352v0.064a6.088,6.088,0,0,0-4.177-4.165h0.083c-0.138-.04-0.314-0.077-0.462-0.116-0.028-.007-0.053-0.016-0.081-0.022-3.61-.954-10.131-1.6-17.624-1.6s-14.015.644-17.624,1.6c-0.027.006-.053,0.015-0.08,0.021-0.149.039-.325,0.077-0.463,0.117h0.083a6.09,6.09,0,0,0-4.183,4.182V387.83c-0.039.134-.075,0.3-0.113,0.446-0.008.035-.02,0.068-0.026,0.1C456.645,391.99,456,398.507,456,406s0.642,14.006,1.6,17.616c0.006,0.035.018,0.069,0.026,0.1,0.038,0.143.074,0.313,0.113,0.446v-0.08a6.091,6.091,0,0,0,4.205,4.188h-0.105c3.479,1.033,10.307,1.736,18.167,1.736s14.688-.7,18.167-1.736h-0.105a6.088,6.088,0,0,0,4.2-4.171v0.063C502.3,424.056,502.327,423.92,502.357,423.808Z",
    transform: "translate(-456 -382)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#002f38",
    fillRule: "evenodd",
    d: "M488.414,399.586a2,2,0,0,1,0,2.828l-10,10a2,2,0,0,1-2.828,0l-4-4a2,2,0,0,1,2.828-2.828L477,408.172l8.586-8.586A2,2,0,0,1,488.414,399.586Z",
    transform: "translate(-456 -382)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNav1);
export default __webpack_public_path__ + "static/media/nav-1.f1e0b84e.svg";
export { ForwardRef as ReactComponent };